import { Button } from '@mui/material'
import { styled } from '@mui/system'

export const UnderlineButton = styled(Button)({
    color: 'white',
    '&:hover': {
        textDecoration: 'underline',
    },
})
